
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefgate",
      function () {
        return require("private-next-pages/debtreliefgate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefgate"])
      });
    }
  